import { jsxs as i, jsx as o } from "react/jsx-runtime";
import { useMultiStyleConfig as p, chakra as s } from "@chakra-ui/react";
const a = ({ descriptionLineOne: r, descriptionLineTwo: l }) => {
  const { description: t, descriptionContainer: c } = p("FileUploader");
  return !r && !l ? null : /* @__PURE__ */ i(s.div, { __css: c, children: [
    !!r && /* @__PURE__ */ o(s.p, { sx: t, children: r }),
    !!l && /* @__PURE__ */ o(s.p, { sx: t, children: l })
  ] });
};
export {
  a as Description
};
//# sourceMappingURL=Description.es.js.map
